import ReactLoading from 'react-loading';

export const Loading = ({ type, color }) => (
	<div className="container py-5 px-4 px-lg-5 my-auto">
		<div className="d-flex align-items-center justify-content-center mb-5">
			<ReactLoading type={type} color={color} height={340} width={155} />
		</div>
	</div>
)